var _rect, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHdfcergoLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 40,
    viewBox: "0 0 52 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.666016,
    width: 51.3333,
    height: 40,
    fill: "url(#pattern0)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_3681_31175",
    transform: "scale(0.012987 0.0166667)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_3681_31175",
    width: 77,
    height: 60,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAE0AAAA8CAMAAAAUqcfmAAAAbFBMVEXYKhv////YJRfXIRLpY0rqaVDzvrfrj4b52dbxq6T41NDWGgrbNif99PL76ObhVEjmc2jslY3dQTPzuLL64d7++fjkZVn87+3aMSL1ysbpgXfcPC7iXFDfTT/kal/vpJzxsannem/1xsH0kHc+jVFkAAADg0lEQVRYhe2YWZOjIBCAEWaCJ95oUDRx/v9/XLrxQGN2s1WpfdhKP2TodPjS0JcT8vP1PvkhX4y+S9gX+abkXUK/P7QP7T+lMXZupMzKwYo0OoZhqBio3dUsNegopSrM20yFq1wLalhFNl4utzzTlD3Q2OR5Xo60IjHLFPRZhKKE5ZvuGUA3NrOSTAN9oF0OtIuz2xupS6s1SyvHOv0lzcsi17eiq3ZG9hLN72UvEVsRoAlupR2R4o88L4XXdK/5dsWYBbCz56BHVjq8M07A3OXBLqobTWDIfG+lUYyxgK1AqzIUPeBd2tygtH3MELa/J4dGMNwB32y5wk/sEuN12s0sby4N7jApniT1X/sG61r/iVbKwcg92dFo0Sz3llxR7hkwVWR3n1UW0niEUdrHlJRrTMN5yKXwjuixTOMxP6ms03yTg8yumFqYb+GyBd+rS5WpQBxu8PVaWGhM7ozBa7Wwylynq2+M73BuQF7vISuNsGyrVJHHRxodfd9f+ptZatBBwsvc38z6tm1i8b30RdJUYH64NxNptnRT2MxmDfoi5gkjbdwStlyRsZIi1R09Nl/rmwo20XJZ5UOL+5nmk19VYSCJzeiCT6IR1cSLQ4Ft97aIdC7Zl+bjlCeLPkE+sLtY9Iaf+LarLJfmJemu8Xp+TJlyI/ose/0S5aKBJsxqqs2ijDC9mlEpPACP0gSd6nuOLsrzfLOVZQR8uYAyGJxoAdKkYIDOGeJrLY3dcp/MhZlmT3bBbzRpJXBLDkVO4zRNdSxWM4J3peX0kAF7a7/6ht8dDstxKGZNpOH83NKwnfTsjLaEDYvSV0pxyPgcdkA7i8sJJMBrtIOKOevf0hap4rul0c6mSfUibY4pd2hJqSM8TWpodrz7KZxUOSeVp7RdFMIe2qQwVYjN8W5KS0owVAVEobS08XkUDhmCE30itIWZeDUlxTDzKgJjJ+kjSiMtnmdIaedlFnNMAYbB5Mym/q0wIc2QhkcVSus79qXhPHsXkZY2n8MMTjQ21ymEm6vauVnWNf4ZT2b9Q9VPzCQrnNEUZntzrKKlTheoc/JIo4HYpFfmBR4vmASVmzklSwGe1I3pSi10qDxs6rrxx+PIt92yjTdBBR8vqNWhfca671NdtNYV0z07rQvy8Bg7P/c6/xWiMhudFWPUncWUHiezQ3uTfGgf2j+mvffXlbf+8vMLxrJCFJ5PHzwAAAAASUVORK5CYII="
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHdfcergoLogo);
export default __webpack_public_path__ + "static/media/hdfcergo_logo.887db27b4c938285e016db850aac3704.svg";
export { ForwardRef as ReactComponent };